// @ts-nocheck

import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import useMergeProps from '../../../hooks/useMergeProps';
import MPHeader from '../components/MPHeader';
import { selectMPTotalNbCards, selectMPUserNbCardsWon } from '../selectors/user';

type MPHeaderProps = {
  className?: string;
};

const MPHeaderContainer = (ownProps: MPHeaderProps) => {
  const userNbWonCards = useSelector(selectMPUserNbCardsWon);
  const totalNbCards = useSelector(selectMPTotalNbCards);

  const selectedProps = useMemo(
    () => ({
      userNbWonCards,
      totalNbCards,
    }),
    [userNbWonCards, totalNbCards],
  );

  const enhancedProps = useMergeProps({ selectedProps, ownProps });

  return <MPHeader {...enhancedProps} />;
};

export default MPHeaderContainer;
